import React from "react";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

const defaultAvatar = "https://via.placeholder.com/48x48";

export interface ContentCardProps {
  title: string;
  description: string;
  image: string;
  avatar?: string;
  displayName: string;
  likes: number;
  createdAt?: number;
}

const ContentCard = ({
  title,
  description,
  image,
  avatar = defaultAvatar,
  displayName,
  likes,
  createdAt = Date.now(),
}: ContentCardProps) => {
  const formattedTime = moment(createdAt).fromNow();

  return (
    <div className="flex items-center overflow-hidden">
      <div className="w-full mx-auto max-w-md bg-white shadow-lg">
        <div className="flex items-center justify-between px-4">
          <div className="flex justify-between items-center py-2">
            <img className="w-8 rounded-full" src={avatar} alt={displayName} />
            <div className="ml-3">
              <h1 className="text-sm font-bold text-gray-800 cursor-pointer">
                {displayName}
              </h1>
              <p className="text-xs text-gray-400 hover:underline cursor-pointer">
                {formattedTime}
              </p>
            </div>
          </div>
        </div>
        <img className="max-h-[24rem] mx-auto" src={image} alt="picsum" />

        <div className="px-4 py-1">
          <p className="text-gray-800 font-semibold text-base cursor-pointer first-letter:capitalize">
            <span>{title}</span>
          </p>
          <p className="text-gray-700 font-thin text-xs first-letter:capitalize">
            {description}
          </p>
        </div>
        <div className="flex w-full">
          <div className="mt-3 mx-5 flex flex-row">
            <div className="flex text-gray-700 font-normal text-xs rounded-md mb-2 mr-4 items-center">
              <span>
                <FontAwesomeIcon
                  icon={regular("heart")}
                  className="text-gray-400 text-base"
                />
              </span>
              <div className="ml-1 text-gray-400 font-thin text-ms">
                {likes}
              </div>
            </div>
          </div>
          {/* <div className="mt-3 mx-5 w-full flex justify-end">
            <div className="flex text-gray-700 font-normal text-xs rounded-md mb-2 mr-4 items-center">
              <span>
                <FontAwesomeIcon
                  icon={regular("comment")}
                  className="text-gray-500 text-base"
                  data-fa-transform="flip-h"
                />
              </span>
              <div className="ml-1 text-gray-400 font-thin text-ms">2.1k</div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ContentCard;
